import { Add } from "@mui/icons-material";
import { FormHelperText } from "@mui/material";
import { FallbackSvg } from './FallbackSvg';
import { WorkflowServiceIcon } from './WorkflowServiceIcon';

type ServiceCardProps = {
    serviceTitle: string;
    serviceSubtitle?: string;
    className?: string;
    onCardClick?: () => void;
    iconName?: string;
}

// Add this helper function to handle SVG rendering
const renderIcon = (icon: string | React.ReactNode) => {
    if (typeof icon === 'string') {
        return <img src={icon} alt="service icon" onError={(e) => {
            e.currentTarget.src = `${icon}.svg`;
        }} />;
    }
    return icon;
};

const ServiceCard = ({
    serviceTitle,
    serviceSubtitle,
    className,
    onCardClick,
    iconName,
}: ServiceCardProps) => {
    return (
        <div className={"border border-solid border-borderGrey p-3 flex gap-2 justify-between rounded-lg cursor-pointer "+className} onClick={onCardClick}>
            <WorkflowServiceIcon
                workflowType={serviceTitle || ''}
                alt={serviceTitle}
                height={32}
                width={32}
            />
            <div className="flex-1 text-xs">
                <div className="font-medium capitalize">{serviceTitle}</div>
                <FormHelperText>{serviceSubtitle}</FormHelperText>
            </div>
            <Add className="!text-sm text-greyishBlue" />
        </div>
    )
}

export default ServiceCard;